<template>
  <section v-if="beta_features.includes('PREMIUM_SUBSCRIPTIONS')">
    <title>User | Subscriptions</title>
    <div class="box">
      <div class="section-title">
        <b>Subscriptions</b>
      </div>

      <div class="subscription-section">
        <div class="section-loader" v-if="!contentLoaded"><div class="page-pulse"><div></div><div></div><div></div></div></div>

        <div class="empty-section-container" v-if="subscriptions.length < 1 && showContent">
          <div class="empty-section-icon"><i class="fas fa-star"></i></div>
          <div class="empty-section-title">Create a subscription quick & easy</div>
          <div class="empty-section-description">Create a subscription and enjoy the finest quality of moderation, pay with Card or PayPal.</div>
          <a class="empty-section-button solid-button background-purple color-white thin-button" href="/premium#plans"><i class="fas fa-plus"></i> Create subscription</a>
        </div>

        <div class="empty-section-container" v-if="error">
          <div class="empty-section-icon"><i class="fas fa-exclamation-triangle"></i></div>
          <div class="empty-section-title">An error occured!</div>
          <div class="empty-section-description">Something, somewhere didn't work right, you can try to refresh the page.</div>
          <a class="empty-section-button solid-button background-purple color-white thin-button" href="/support"><i class="fas fa-headset"></i> Support server</a>
        </div>

        <div class="subscription-populated-list" v-if="subscriptions.length > 0 && showContent">
          <!-- <ul class="subscription-list">
            <li class="subscription-item" v-for="item in subscriptions" :key="item.id">
              <div class="card-title-options">
                <h2 class="card-title">{{ getProductById(item.tier) }}</h2>
                <a class="card-button solid-button background-red color-white small-button" @click="() => cancelSubscription(item.id)"><i class="fas fa-times-circle"></i></a>
              </div>

              <div class="card-info-box">
                <p class="card-status">Status: <span v-bind:style="`color: ${getStatusColor(item.status)};`">{{ titleCase(item.status) }}</span></p>
                <p class="card-next-date">Next Payment: {{ formatDate(item.next_billing_at) }}</p>
                <p class="card-created-date">Subscribed: {{ formatDate(item.created_at) }}</p>
              </div>

              <v-select
                :options="getSerializedGuilds(guildCollection)"
                @input="(input_guilds) => updateSubscription(item.id, input_guilds)"
                :max="item.slot_count"
                :value="getSerializedGuilds(getSubscriptionGuilds(item))"
                multiple
              ></v-select>
            </li>
          </ul> -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import StatusCodes from "../utils/ResponseCodes";
import moment from "moment";

export default {
  name: "Subscriptions",
  data () {
    return {
      loaded: false,
      error: false,
      meta_guilds: [],
      products: [],
      subscriptions: [],
      status_colors: {
        active: "#28a745", // green
        suspended: "#dc3545",
        expired: "#dc3545",
        cancelled: "#dc3545",
        canceled: "#dc3545",
        ended: "#dc3545",
        unpaid: "#dfa32b", // yellow
        incomplete: "#dc3545",
        incomplete_expired: "#dc3545", // red
        trialing: "#28a745",
        past_due: "#dc3545",
        approval_pending: "#ffffff",
        approved: "#dfa32b"
      }
    };
  },
  watch: {
    login_queried () {
      this.loadSubscriptions();
    }
  },
  mounted () {
    if (this.login_queried) this.loadSubscriptions();
  },
  computed: {
    contentLoaded () {
      return this.loaded;
    },
    showContent () {
      return this.loaded && !this.error;
    },
    guildCollection ()  {
      console.log(this.guilds);
      const guilds = (new Array()).concat(this.guilds, this.meta_guilds);
      return guilds.map(guild => ({
        name: guild.name,
        id: guild.id
      }));
    },
    ...mapGetters(["id", "login_queried", "guilds", "beta_features"])
  },
  methods: {
    async loadSubscriptions () {
      const { status, payload } = await this.$rest.api
        .users(this.id)
        .subscriptions
        .get()
        .catch(() => {});
      
      this.loaded =  true;
      if (status !== 200 || payload.status_code !== StatusCodes.SUCCESS) return this.error = true;

      this.meta_guilds = payload.guilds;
      this.subscriptions  = payload.subscriptions;
      this.products = payload.products;
    },
    titleCase (str) {
      return str.replace(
        /\w\S*/g,
        function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
      );
    },
    getProductById (id) {
      const tier = this.products.find(product => product.tier === id);
      return tier ? tier.name : "Unknown Plan";
    },
    isCancelable (item) {
      if (item.status && item.status.toLowerCase() === "active") return true;
      return false;
    },
    formatDate (date) {
      return moment(date).format("Do of MMMMs YYYY");
    },
    getStatusColor (status = "incomplete") {
      const color = this.status_colors[status.toLowerCase()];
      return color ? color : "#ffffff";
    },
    serializeGuilds (guilds = []) {
      return guilds.map(guild => ({
        label: guild.name,
        value: guild.id
      }));
    }
  }
}
</script>

<style scoped>
</style>